import { render, staticRenderFns } from "./sysHeader.vue?vue&type=template&id=2dfebbcc&scoped=true&"
import script from "./sysHeader.vue?vue&type=script&lang=js&"
export * from "./sysHeader.vue?vue&type=script&lang=js&"
import style0 from "./sysHeader.vue?vue&type=style&index=0&id=2dfebbcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfebbcc",
  null
  
)

export default component.exports